module.exports = __webpack_public_path__ + "img/bg6.36cb3d0b.png";